import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import StarIcon from '@mui/icons-material/Star';
import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, LinearProgress, Paper, Rating, Skeleton, Typography , TextField, Alert, Snackbar, InputAdornment, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, List, ListItem} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { DashboardData, dashboardService } from '../../services/api/dashboardService';
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TextareaAutosize from "@mui/material/TextareaAutosize";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Modal from '@mui/material/Modal';
import QrCode2Icon from "@mui/icons-material/QrCode2";
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import axios from 'axios';
import api from '../../services/api/axiosConfig';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { bookingService, ExtendStayRequest } from '../../services/api/bookingService';


// Table 
interface Column {
  id: 'date' | 'lockertype' | 'duration' | 'status';
  label: string;
  minWidth?: number;
  align?: 'left';
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: 'date', label: 'DATE', minWidth: 170 },
  { id: 'lockertype', label: 'LOCKER TYPE', minWidth: 100 },
  {
    id: 'duration',
    label: 'DURATION',
    minWidth: 170,
    align: 'left',
    // format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'status',
    label: 'STATUS',
    minWidth: 170,
    align: 'left',
    // format: (value: number) => value.toLocaleString('en-US'),
  },
];

interface Data {
  date: string;
  lockertype: string;
  duration: string;
  status: string;
}
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


interface PaymentColumn {
  id: 'date' | 'status' | 'description' | 'amount';
  label: string;
  minWidth?: number;
  align?: 'left';
  format?: (value: number) => string;
}

const paymentColumns: PaymentColumn[] = [
  { id: 'date', label: 'DATE', minWidth: 170 },
  { id: 'status', label: 'STATUS', minWidth: 100 },
  {
    id: 'description',
    label: 'DESCRIPTION',
    minWidth: 170,
    align: 'left',
    // format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'amount',
    label: 'AMOUNT',
    minWidth: 170,
    align: 'left',
    // format: (value: number) => value.toLocaleString('en-US'),
  },
];


interface PaymentData {
  date: string;
  status: string;
  description: string;
  amount: string;
}


const DashboardContent = () => {
  const { user } = useAuth();
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showPin, setShowPin] = useState(false);
  const [selected, setSelected] = useState("Bookings");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paymentPage, setPaymentPage] = useState(0);
  const [paymentRowsPerPage, setPaymentRowsPerPage] = useState(10);
  const [rating, setRating] = useState(3); // clicked rating
  const [hover, setHover] = useState(0);  // hover temporary rating
  const [message, setMessage] = useState("");   // current textarea
  const [latestMessage, setLatestMessage] = useState(""); // last sent
  const [issueMessage, setIssueMessage] = useState("");  
  const [success, setSuccess] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false); 
  const [value, setValue] = useState<Date | null>(null);
  const [calenderOpen, setCalenderOpen] = useState(false);
  const [time, setTime] = useState<Date | null>(null);  // Must be Date type
  const [openTime, setOpenTime] = useState(false);
  const [selectedSection, setSelectedSection] = useState("Guest Overview");
  const [openToast, setOpenToast] = useState(false);
  const [progress, setProgress] = useState(100);
  const [toastMessage, setToastMessage] = useState("");
  const [issueValue, setIssueValue] = useState("");
  const [openCancellationModal, setOpenCancellationModal] = useState(false);
  const handleOpenCancellationModal = () => setOpenCancellationModal(true);
  const handleCloseCancellationModal = () => setOpenCancellationModal(false);
  const [openQrModal, setOpenQrModal] = useState(false);
  const [bookings, setBookings] = useState<any>([]); 
  const [currentBookingStatus, setCurrentBookingStatus] = useState("");     // store booking status
  const [currentBookingCheckIn, setCurrentBookingCheckIn] = useState("");
  const [currentBookingCheckOut, setCurrentBookingCheckOut] = useState("");
  const [currentBookingPin, setCurrentBookingPin] = useState<string>("");
  const [totalBookings, setTotalBookings] = useState(0);
  const [avgStayDuration, setAvgStayDuration] = useState(0);
  const [updatedMappedRows, setUpdatedMappedRows] = useState<any>([]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [totalPaymentHistory, setTotalPaymentHistory] = useState(0);
  const [bookingsLoading, setBookingsLoading] = useState(false);
  const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [extendStayLoading, setExtendStayLoading] = useState(false);
  const [cancelBookingLoading, setCancelBookingLoading] = useState(false);
  const [deviceLocked, setDeviceLocked] = useState<boolean>(false); // true = locked, false = unlocked
  const [lockUnlockLoading, setLockUnlockLoading] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [extendDialogOpen, setExtendDialogOpen] = useState(false);
  const [selectedExtension, setSelectedExtension] = useState<'4hours' | '8hours' | 'fullday' | null>(null);
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

 
  const rows = bookings.map((item: any) => {
    const checkIn = new Date(item.check_in);
    const checkOut = new Date(item.check_out);
  
    const diffHours = Math.round((checkOut.getTime() - checkIn.getTime()) / (1000 * 60 * 60));
    const durationText =
      diffHours >= 24 ? `${Math.floor(diffHours / 24)} Days` : `${diffHours} Hours`;
  
    return {
      id: item.id,
      date: formatDate(item.check_in),
      lockertype: item.botel?.name || "N/A",
      duration: durationText,
      status: item.identity_verified ? "Identity Verified" : "Identity Not Verified",
    };
  });

  const paymentRows = paymentHistory.map((item: any) => {
    const booking = item.booking;
  
    return {
      date: formatDate(item.created_at),
      status: item.payment_status || "N/A",
      description: booking?.botel?.name
        ? `${booking.botel.name}`
        : `Booking #${booking.id}`,
      amount: "$ " + Number(item.amount).toFixed(2),
    };
  });
  
  
  const handleOpenQrModal = () => setOpenQrModal(true);
  const handleCloseQrModal = () => setOpenQrModal(false);
  
  const navigate = useNavigate();


  const pin = currentBookingPin || "Not Generated";

  const handleIssueValueChange = (event: SelectChangeEvent<string>) => {
    setIssueValue(event.target.value);
  };

  const handleClick = () => {
    setOpenToast(true);
    setProgress(100);
  };
  const handleClose = () => setOpenToast(false);
  useEffect(() => {
    if (!openToast) return;

    const interval = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress <= 0) {
          clearInterval(interval);
          handleClose();
          return 0;
        }
        return oldProgress - 1;
      });
    }, 30); // 30ms × 100 steps = ~3 seconds
    return () => clearInterval(interval);
  }, [openToast]);
  useEffect(() => {
    setSelectedSection("Guest Overview");
  },[])
  const handleSend = () => {
    if (!message.trim()) {
      setErrorMessage(true);
      setSuccess(false);
  
      // Hide error after 2 seconds
      setTimeout(() => setErrorMessage(false), 2000);
      return;
    }
  
    setLatestMessage(message); // save latest message
    setMessage("");            // clear textarea
    setErrorMessage(false);           // hide error
    setSuccess(true);          // show success
  
    // Hide success after 2 seconds
    setTimeout(() => setSuccess(false), 2000);
  };

  const handleIdentityVerification = async () => {
    if (!bookings || bookings.length === 0) {
      handleClick();
      setToastMessage("No booking found. Please try again.");
      return;
    }

    // Use botel.id as specified, with fallback to booking.id
    const bookingId = bookings[0]?.id;
    
    if (!bookingId) {
      handleClick();
      setToastMessage("Booking ID not found. Please try again.");
      return;
    }

    try {
      setVerificationLoading(true);
      const response = await api.post('/verification/send-verification-email', {
        bookingId: bookingId
      });

      if (response.status === 200 || response.status === 201) {
        handleClick();
        setToastMessage("Verification email sent successfully! Please check your inbox.");
        setEmailSent(true);
      }
    } catch (error: any) {
      console.error("Error sending verification email:", error);
      handleClick();
      setToastMessage(
        error.response?.data?.message || 
        "Failed to send verification email. Please try again."
      );
    } finally {
      setVerificationLoading(false);
    }
  };

  const getExtensionPrice = (type: '4hours' | '8hours' | 'fullday') => {
    switch (type) {
      case '4hours': return 20.00;
      case '8hours': return 35.00;
      case 'fullday': return 50.00;
      default: return 0;
    }
  };

  const handleExtendStay = async () => {
    if (!selectedExtension) {
      handleClick();
      setToastMessage("Please select an extension option.");
      return;
    }

    if (!bookings || bookings.length === 0 || !bookings[0]?.id) {
      handleClick();
      setToastMessage("No booking found. Please try again.");
      return;
    }

    try {
      setExtendStayLoading(true);
      
      const bookingId = bookings[0].id;
      const currentBooking = bookings[0];
      const extensionPrice = getExtensionPrice(selectedExtension);
      
      // Calculate extended hours
      const extensionHours = selectedExtension === '4hours' ? 4 : selectedExtension === '8hours' ? 8 : 24;
      
      // Save booking details and extension info to session storage
      const extensionData = {
        bookingId: bookingId,
        booking: currentBooking,
        extensionType: selectedExtension,
        extensionHours: extensionHours,
        extensionAmount: extensionPrice,
        isExtension: true
      };
      
      sessionStorage.setItem('extensionData', JSON.stringify(extensionData));
      
      // Save booking details for payment page (similar to new booking flow)
      const bookingDetails = {
        bookingId: bookingId,
        baseRate: extensionPrice,
        insurancePrice: 0,
        overstayPrice: 0,
        taxesAndFees: 0,
        total: extensionPrice,
        isExtension: true,
        extensionType: selectedExtension,
        extensionHours: extensionHours,
        originalBooking: currentBooking
      };
      
      sessionStorage.setItem('bookingDetails', JSON.stringify(bookingDetails));
      
      setExtendDialogOpen(false);
      setSelectedExtension(null);
      
      // Redirect to payment details page
      navigate('/payment-details');
    } catch (error: any) {
      console.error("Error extending stay:", error);
      handleClick();
      setToastMessage(
        error.response?.data?.message || 
        error.message ||
        "Failed to extend stay. Please try again."
      );
    } finally {
      setExtendStayLoading(false);
    }
  };

  const handleCheckout = async () => {
    if (!bookings || bookings.length === 0 || !bookings[0]?.id) {
      handleClick();
      setToastMessage("No booking found. Please try again.");
      return;
    }

    try {
      setCheckoutLoading(true);
      
      const bookingId = bookings[0].id;
      const checkedOutTime = new Date().toISOString();
      
      const response = await api.patch(`/bookings/${bookingId}`, {
        checkedOutTime: checkedOutTime,
        status: "checked out"
      });

      if (response.status === 200 || response.status === 204) {
        // Update the bookings array with the new status
        if (bookings.length > 0) {
          const updatedBookings = [...bookings];
          updatedBookings[0] = {
            ...updatedBookings[0],
            status: "checked out",
            checked_out_time: checkedOutTime
          };
          setBookings(updatedBookings);
        }
        
        handleClick();
        setToastMessage("You have successfully checked out! Thank you.");
        setSelectedSection("Guest Overview");
      }
    } catch (error: any) {
      console.error("Error checking out:", error);
      handleClick();
      setToastMessage(
        error.response?.data?.message || 
        "Failed to check out. Please try again."
      );
    } finally {
      setCheckoutLoading(false);
    }
  };

  const handleCancelBooking = async () => {
    if (!bookings || bookings.length === 0 || !bookings[0]?.id) {
      handleClick();
      setToastMessage("No booking found. Please try again.");
      return;
    }

    try {
      setCancelBookingLoading(true);
      const bookingId = bookings[0].id;
      
      const response = await api.post(`/bookings/${bookingId}/cancel`, {
        reason: cancelReason || undefined
      });

      if (response.status === 200 || response.status === 201) {
        handleCloseCancellationModal();
        handleClick();
        setToastMessage("Booking cancelled! Thank you.");
        setCancelReason("");
        // Update bookings to reflect cancellation
        if (bookings.length > 0) {
          const updatedBookings = [...bookings];
          updatedBookings[0] = {
            ...updatedBookings[0],
            status: "cancelled",
            cancelled_at: new Date().toISOString()
          };
          setBookings(updatedBookings);
        }
      }
    } catch (error: any) {
      console.error("Error cancelling booking:", error);
      handleClick();
      setToastMessage(
        error.response?.data?.message || 
        "Failed to cancel booking. Please try again."
      );
    } finally {
      setCancelBookingLoading(false);
    }
  };

  // TABLE 
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handlePaymentChangePage = (event: unknown, newPage: number) => {
    setPaymentPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handlePaymentChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPaymentRowsPerPage(+event.target.value);
    setPaymentPage(0);
  };
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await dashboardService.getDashboardData();
        setDashboardData(data);
      } catch (err) {
        console.error('Failed to fetch dashboard data:', err);
        setError('Failed to load dashboard data');
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchDashboardData();
    }
  }, [user]);

  const formatTimeUntilCheckIn = (days: number, hours: number, minutes: number) => {
    if (days < 0) return 'Check-in has passed';
    if (days === 0 && hours === 0 && minutes === 0) return 'Check-in now!';
    
    const parts = [];
    if (days > 0) parts.push(`${days} Days`);
    if (hours > 0) parts.push(`${hours} Hours`);
    if (minutes > 0) parts.push(`${minutes} Minutes`);
    
    return parts.join(', ');
  };



  const getLoyaltyProgress = (points: number, tier: string) => {
    switch (tier) {
      case 'Bronze':
        return Math.min((points / 1500) * 100, 100);
      case 'Silver':
        return Math.min(((points - 1500) / 1500) * 100, 100);
      case 'Gold':
        return 100;
      default:
        return 0;
    }
  };
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        setBookingsLoading(true);
        const response = await api.get("/bookings/list?includeStats=true", {
          params: {
            page: page + 1,
            size: rowsPerPage,
            // search: "john",     // optional  
            // status: "CONFIRMED" // optional  
          }
        });


        // If you only want the list of bookings:

        // If you want pagination details:
        setBookings(response.data.data);
        setTotalBookings(response.data.totalItems);
        setAvgStayDuration(response.data.stats.averageStayDurationHours);
      } 
      catch (error) {
        console.error("Error fetching bookings:", error);
      } finally {
        setBookingsLoading(false);
      }
    };

    fetchBookings();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const fetchPaymentHistory = async () => {
      try {
        setPaymentHistoryLoading(true);
        const response = await api.get(
          `/payments/payments-transactions/history?page=${paymentPage + 1}&size=${paymentRowsPerPage}&includeStats=true&sort=created_at,desc`
        );
  
        setPaymentHistory(response.data.data);
        setTotalPaymentHistory(response.data.totalItems);
      } catch (error) {
        console.error("Error fetching payment history:", error);
      } finally {
        setPaymentHistoryLoading(false);
      }
    };
  
    fetchPaymentHistory();
  }, [paymentPage, paymentRowsPerPage]);
  

   // Function to calculate booking status
   const getBookingStatus = (check_in: string, check_out: string, bookingStatus?: string) => {
    // If booking is cancelled, return "cancelled"
    if (bookingStatus === "cancelled") {
      return "cancelled";
    }
    if (bookingStatus === "checked out") {
      return "checked out";
    }

    const now = new Date();
    const start = new Date(check_in);
    const end = new Date(check_out);

    if (now < start) return "Upcoming";
    if (now > end) return "Completed";
    return "Ongoing"; // check_in <= now <= check_out
  };
  // When "bookings" changes
  
  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
  
    return date.toLocaleString("en-US", {
      month: "short",      // Jun
      day: "numeric",      // 10
      year: "numeric",     // 2025
      hour: "numeric",     // 3
      minute: "2-digit",   // 00
      hour12: true         // PM
    });
  };
  

  useEffect(() => {
    if (bookings.length > 0) {
      const first: any = bookings[0];
  
      // --- Get Status ---
      const statusValue = getBookingStatus(first.check_in, first.check_out, first.status);
      setCurrentBookingStatus(statusValue);
  
      // --- Convert Dates ---
      const formattedCheckIn = formatDateTime(first.check_in);
      const formattedCheckOut = formatDateTime(first.check_out);
  
      // --- Update States ---
      setCurrentBookingCheckIn(formattedCheckIn);
      setCurrentBookingCheckOut(formattedCheckOut);
    }
  }, [bookings]);

  useEffect(() => {
    const fetchBookingPin = async () => {
      if (!bookings || bookings.length === 0 || !bookings[0]?.id || bookings[0]?.status === "cancelled" || bookings[0]?.status === "checked out") {
        return;
      }

      try {
        const bookingId = bookings[0].id;
        const response = await api.get(`/verification/booking/${bookingId}/pin`);
        if (response.data?.pin) {
          setCurrentBookingPin(response.data.pin);
        }
      } catch (error: any) {
        console.error("Error fetching booking PIN:", error);
        // Don't show error toast as PIN might not be available yet
      }
    };

    fetchBookingPin();
  }, [bookings]);

  // Set date and time from bookings[0].check_out
  useEffect(() => {
    if (bookings && bookings.length > 0 && bookings[0]?.check_out) {
      const checkOutDate = new Date(bookings[0].check_out);
      
      // Set the date (value) - DatePicker will extract the date part
      setValue(checkOutDate);
      
      // Set the time (time) - TimePicker will extract the time part
      setTime(checkOutDate);
    }
  }, [bookings]);

  // Local rounded star used for custom rating control
  const RoundedStar = ({ filled }: { filled: boolean }) => (
    <StarIcon
      sx={{
        color: filled ? '#F55446' : 'transparent',
        stroke: '#F55446',
        strokeWidth: 1,
        fontSize: 36,
      }}
    />
  );

  if (loading) {
    return (
      <Box sx={{ 
        flexGrow: 1, 
        p: { xs: 1, sm: 2, md: 3 }, 
        background: '#151A23', 
        minHeight: '100vh', 
        color: '#fff', 
        marginTop: 10
      }}>
        {/* Header Skeleton */}
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }} elevation={4}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="rectangular" width={48} height={48} sx={{ background: '#181F2A', borderRadius: 2 }} />
            <Box>
              <Skeleton variant="text" width={200} height={32} sx={{ background: '#90caf9' }} />
              <Skeleton variant="text" width={150} height={20} sx={{ background: '#90caf9' }} />
            </Box>
          </Box>
        </Paper>

        {/* Current Stay Skeleton */}
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: 2, gap: 2 }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width={250} height={24} sx={{ background: '#90caf9', mb: 1 }} />
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Skeleton variant="text" width={120} height={20} sx={{ background: '#90caf9' }} />
                <Skeleton variant="text" width={80} height={20} sx={{ background: '#90caf9' }} />
                <Skeleton variant="text" width={150} height={20} sx={{ background: '#90caf9' }} />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
              <Skeleton variant="rectangular" width={120} height={36} sx={{ background: '#90caf9', borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={120} height={36} sx={{ background: '#90caf9', borderRadius: 2 }} />
              <Skeleton variant="rectangular" width={120} height={36} sx={{ background: '#90caf9', borderRadius: 2 }} />
            </Box>
          </Box>
          <Box sx={{ background: '#181F2A', p: 2, borderRadius: 2, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
            <Box>
              <Skeleton variant="text" width={140} height={20} sx={{ background: '#90caf9', mb: 1 }} />
              <Skeleton variant="text" width={180} height={28} sx={{ background: '#90caf9' }} />
            </Box>
            <Skeleton variant="rectangular" width={160} height={36} sx={{ background: '#90caf9', borderRadius: 2 }} />
          </Box>
        </Paper>

        {/* Protect Stay Skeleton */}
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Skeleton variant="text" width={150} height={24} sx={{ background: '#90caf9' }} />
              <Skeleton variant="rectangular" width={80} height={24} sx={{ background: '#90caf9', borderRadius: 1 }} />
            </Box>
            <Skeleton variant="circular" width={24} height={24} sx={{ background: '#90caf9' }} />
          </Box>
          <Skeleton variant="text" width={200} height={20} sx={{ background: '#90caf9', mb: 2 }} />
          <Box sx={{ background: '#1976d2', borderRadius: 2, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Skeleton variant="text" width={120} height={20} sx={{ background: '#fff' }} />
            <Skeleton variant="rectangular" width={60} height={24} sx={{ background: '#fff', borderRadius: 2 }} />
          </Box>
        </Paper>

        {/* Main Grid Skeleton */}
        <Grid container spacing={3}>
          <Grid size={{xs: 12, md: 8, lg: 8, xl: 8}} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Booking History Skeleton */}
            <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
              <Skeleton variant="text" width={150} height={32} sx={{ background: '#90caf9', mb: 2 }} />
              <Divider sx={{ my: 2, background: '#333' }} />
              <Box sx={{ display: 'flex', gap: 2, overflowX: { xs: 'auto', md: 'visible' }, pb: { xs: 1, md: 0 } }}>
                {[1, 2, 3].map((index) => (
                  <Paper key={index} sx={{ p: 2, background: '#181F2A', flex: '0 0 260px', minWidth: 220, borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mr: 2 }} elevation={2}>
                    <Skeleton variant="text" width={180} height={24} sx={{ background: '#90caf9', mb: 1 }} />
                    <Skeleton variant="text" width={140} height={16} sx={{ background: '#90caf9', mb: 2 }} />
                    <Skeleton variant="rectangular" width={80} height={24} sx={{ background: '#90caf9', borderRadius: 2 }} />
                  </Paper>
                ))}
              </Box>
            </Paper>

            {/* Loyalty & Rewards Skeleton */}
            <Paper sx={{ p: { xs: 2, md: 3 }, background: '#1F262C', borderRadius: 3 }} elevation={4}>
              <Skeleton variant="text" width={200} height={32} sx={{ background: '#90caf9', mb: 1 }} />
              <Skeleton variant="text" width={180} height={20} sx={{ background: '#90caf9', mb: 2 }} />
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <Skeleton variant="rectangular" width="100%" height={10} sx={{ background: '#90caf9', borderRadius: 5, flex: 1 }} />
                <Skeleton variant="text" width={120} height={20} sx={{ background: '#90caf9', ml: 2 }} />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                <Skeleton variant="text" width={50} height={16} sx={{ background: '#90caf9' }} />
                <Skeleton variant="text" width={50} height={16} sx={{ background: '#90caf9' }} />
                <Skeleton variant="text" width={50} height={16} sx={{ background: '#90caf9' }} />
              </Box>
            </Paper>
          </Grid>
          <Grid size={{xs: 12, md: 4}}>
            {/* Reviews Skeleton */}
            <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
              <Skeleton variant="text" width={120} height={32} sx={{ background: '#90caf9', mb: 1 }} />
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mb: 1 }}>
                <Skeleton variant="rectangular" width={100} height={20} sx={{ background: '#90caf9' }} />
                <Skeleton variant="text" width={30} height={20} sx={{ background: '#90caf9' }} />
              </Box>
              <Skeleton variant="text" width="100%" height={20} sx={{ background: '#90caf9', mb: 1 }} />
              <Skeleton variant="text" width="80%" height={20} sx={{ background: '#90caf9', mb: 1 }} />
              <Skeleton variant="text" width={120} height={16} sx={{ background: '#90caf9' }} />
            </Paper>
            {/* Total Stays Skeleton */}
            <Paper sx={{ p: { xs: 2, md: 3 }, background: '#1F262C', borderRadius: 3, textAlign: 'center' }} elevation={4}>
              <Skeleton variant="text" width={100} height={32} sx={{ background: '#90caf9', mb: 1 }} />
              <Skeleton variant="text" width={80} height={60} sx={{ background: '#90caf9', mb: 1 }} />
              <Skeleton variant="text" width={120} height={20} sx={{ background: '#90caf9' }} />
            </Paper>
          </Grid>
        </Grid>

        {/* Footer Skeleton */}
        <Box sx={{ mt: 5, py: 2, borderTop: '1px solid #1F262C', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, color: '#b0b8c1', fontSize: 14 }}>
          <Skeleton variant="text" width={150} height={20} sx={{ background: '#90caf9' }} />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Skeleton variant="rectangular" width={60} height={24} sx={{ background: '#90caf9', borderRadius: 2 }} />
            <Skeleton variant="rectangular" width={80} height={24} sx={{ background: '#90caf9', borderRadius: 2 }} />
          </Box>
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ 
        flexGrow: 1, 
        p: { xs: 1, sm: 2, md: 3 }, 
        background: '#151A23', 
        minHeight: '100vh', 
        color: '#fff', 
        marginTop: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" color="error" sx={{ mb: 2 }}>{error}</Typography>
          <Button 
            variant="contained" 
            onClick={() => window.location.reload()}
            sx={{ borderRadius: 2 }}
          >
            Try Again
          </Button>
        </Box>
      </Box>
    );
  }

  if (!dashboardData) {
    return (
      <Box sx={{ 
        flexGrow: 1, 
        p: { xs: 1, sm: 2, md: 3 }, 
        background: '#151A23', 
        minHeight: '100vh', 
        color: '#fff', 
        marginTop: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6">No data available</Typography>
        </Box>
      </Box>
    );
  }

  const { user: dashboardUser, currentStay, bookingHistory, stats, reviews } = dashboardData;

  return (
    <>
    <Snackbar
        open={openToast}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ "& .MuiAlert-icon":{
          alignItems: "center", p:"7px 0",
          "& svg":{
            ml: "10px",
            mt: "-5px",
          }
        } }}
      >
        <Alert
          severity="success"
          sx={{ width: "300px", p: 0, overflow: "hidden", borderRadius: "8px" }}
        >
          <Box sx={{ p: 1 }}>{toastMessage}</Box>
          <Box
            sx={{
              height: "4px",
              backgroundColor: "#4caf50",
              width: `${progress}%`,
              transition: "width 0.1s linear",
            }}
          />
        </Alert>
      </Snackbar>

      {/* Cancellation Modal Start */}
      <div>
      <Modal
  open={openCancellationModal}
  onClose={handleCloseCancellationModal}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box
    sx={{
      ...style,
      backgroundColor: "#1F262C",
      border: "1px solid #2C353F",
      borderRadius: "12px",
      textAlign: "center",
      p: 4,
      width: 530,
    }}
  >
    <img src="/icons/alert.svg" alt="alert" />

    <Typography
      variant="h6"
      sx={{ fontSize: 22, fontWeight: "600", color: "white", mt: 2 }}
    >
      Confirm Cancellation
    </Typography>

    <Typography sx={{ mt: 1, color: "white" }}>
      Are You Sure You Want To Cancel This Booking? This Action Cannot Be
      Undone.
    </Typography>

    {/* Refund policy left-aligned */}
    <Box sx={{ textAlign: "left", mt: 3 }}>
      <Typography sx={{ fontWeight: "bold", color: "white" }}>
        Refund Policy:
      </Typography>

      <List
        sx={{
          pl: 3,
          color: "white",
          listStyleType: "disc",
          "& .MuiListItem-root": {
            display: "list-item",
            py: 0.2,
          },
        }}
      >
        <ListItem>
          Full refund until 2 hours before start.
        </ListItem>

        <ListItem>
          50% refund until start time.
        </ListItem>

        <ListItem>
          0% refund after start.
        </ListItem>
      </List>
    </Box>

    {/* <Typography sx={{ mt: 1, color: "white" }}>
      Estimated Refund:{" "}
      <span style={{ color: "#27DE16", fontWeight: "bold" }}>$125.00</span>
    </Typography> */}

    {/* Buttons */}
    <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
      <Button
        onClick={handleCloseCancellationModal}
        fullWidth
        sx={{
          backgroundColor: "#6A6E71",
          color: "white",
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#5F6366" },
        }}
      >
        Back
      </Button>

      <Button
        fullWidth
        disabled={cancelBookingLoading}
        sx={{
          backgroundColor: "#E23220",
          color: "white",
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#C72B1B" },
          "&:disabled": { opacity: 0.6 },
        }}
        onClick={handleCancelBooking}
      >
        {cancelBookingLoading ? (
          <>
            <CircularProgress size={16} sx={{ color: 'white', mr: 1 }} />
            Cancelling...
          </>
        ) : (
          "Confirm Cancel"
        )}
      </Button>
    </Box>
  </Box>
</Modal>

<Modal
  open={openQrModal}
  onClose={handleCloseQrModal}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box
    sx={{
      ...style,
      backgroundColor: "#1F262C",
      border: "1px solid #2C353F",
      borderRadius: "12px",
      textAlign: "center",
      p: 4,
      width: 530,
    }}
  >

    <Typography
      variant="h6"
      sx={{ fontSize: 22, fontWeight: "600", color: "white", mt: 2, pb:"20px" }}
    >
     Scan QR Code
    </Typography>

    <Typography sx={{ mt: 1, color: "white", pb:"30px" }}>
    Point your camera at the QR code to
    unlock
    </Typography>

    {/* Refund policy left-aligned */}
    <Box sx={{ textAlign: "center", mt: 3, "& svg":{
      color:"white",
      background:"#16202A",
      borderRadius:"20px"
    }}}>
                    <QrCode2Icon
                      sx={{ fontSize: { xs: 150, md: 200 }, mb: 1 }}
                    />
    </Box>
    {/* Buttons */}
    <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
      <Button
        onClick={handleCloseQrModal}
        fullWidth
        sx={{
          backgroundColor: "#6A6E71",
          color: "white",
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#5F6366" },
        }}
      >
        Back
      </Button>
      <Button
        fullWidth
        sx={{
          backgroundColor: "#2050B3",
          color: "white",
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": { opacity:0.5 },
        }}
        onClick={async () => {
          if (!bookings || bookings.length === 0 || !bookings[0]?.botel_id) {
            handleClick();
            setToastMessage("Botel ID not found. Please try again.");
            return;
          }

          const botelId = bookings[0].botel_id;
          setLockUnlockLoading(true);

          try {
            if (deviceLocked) {
              // Unlock device
              const response = await api.post(`/remote-lock/botels/${botelId}/unlock`);
              const data = response.data;
              if (data?.success) {
                setDeviceLocked(false);
                setOpenQrModal(false);
                handleClick();
                setToastMessage("Device unlocked successfully.");
              } else {
                handleClick();
                setToastMessage("Failed to unlock device. Please try again.");
              }
            } else {
              // Lock device
              const response = await api.post(`/remote-lock/botels/${botelId}/lock`);
              const data = response.data;
              if (data?.success) {
                setDeviceLocked(true);
                setOpenQrModal(false);
                handleClick();
                setToastMessage("Device locked successfully.");
              } else {
                handleClick();
                setToastMessage("Failed to lock device. Please try again.");
              }
            }
          } catch (error: any) {
            console.error('Failed to toggle device lock:', error);
            handleClick();
            setToastMessage(
              error.response?.data?.message || 
              "Failed to toggle device. Please try again."
            );
          } finally {
            setLockUnlockLoading(false);
          }
        }}
        disabled={lockUnlockLoading}
      >
        <img src="/icons/tap-icon.svg" alt="Tap-icon" />
        {lockUnlockLoading ? (
          <CircularProgress size={20} sx={{ color: 'white', ml: 1 }} />
        ) : deviceLocked ? (
          "Tap To Unlock"
        ) : (
          "Tap To Lock"
        )}
      </Button>
    </Box>
  </Box>
</Modal>

    </div>
      {/* Cancellation Modal End */}

      <Box sx={{ background: '#151A23', color: '#fff', marginTop: "64px", mb:"-80px", borderTop:"1px solid #2C353F", borderBottom:"1px solid #2C353F", padding: "17px 31px" }}>
        <Typography sx={{ fontSize: 18, fontWeight: "semibold", color: "#fff" }}>{selectedSection}</Typography>
        </Box>
    {selectedSection === "Guest Overview" && (
    <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
      {/* Header */}
      <Paper sx={{ px: 3, py:2, mb: 3, background: '#1F262C', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }} elevation={4}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ width: 67, height: 80, background: '#131A21', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src="/icons/botel-icon.svg" alt="BOTEL Logo" />
          </Box>
          <Box>
            <Typography fontSize={30} variant="h6" fontWeight="bold">Welcome Back, {dashboardUser.name}!</Typography>
            <Typography fontSize={16} variant="body2">Manage Your Upcoming Stays And Past Bookings</Typography>
          </Box>
        </Box>
      </Paper>
    
      {/* Current Stay */}
      {/* {currentStay ? (
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: 2, gap: 2 }}>
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">Current Stay At {currentStay.booking.botel.name}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <CalendarMonthIcon fontSize="small" sx={{ color: '#90caf9' }} />
                  <Typography variant="body2">{formatDate(currentStay.booking.check_in)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <PersonIcon fontSize="small" sx={{ color: '#90caf9' }} />
                  <Typography variant="body2">1 Guest</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <LocationOnIcon fontSize="small" sx={{ color: '#90caf9' }} />
                  <Typography variant="body2">{currentStay.booking.botel.location_address}</Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', sm: 'auto' } }}>
              <Button variant="contained" color="secondary" sx={{ borderRadius: 2, minWidth: 120 }}>Extend Stay</Button>
              <Button variant="contained" color="primary" sx={{ borderRadius: 2, minWidth: 120 }} onClick={() => navigate(`/client/modify-booking/${currentStay.booking.id}`)}>Modify Booking</Button>
              <Button variant="contained" color="error" sx={{ borderRadius: 2, minWidth: 120 }}>Cancel Booking</Button>
            </Box>
          </Box>
          <Box sx={{ background: '#181F2A', p: 2, borderRadius: 2, mb: 2, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
            <Box>
              <Typography sx={{ color: '#b0b8c1' }}>Check-In Starts In</Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatTimeUntilCheckIn(currentStay.daysUntilCheckIn, currentStay.hoursUntilCheckIn, currentStay.minutesUntilCheckIn)}
              </Typography>
            </Box>
            <Button variant="contained" color="primary" startIcon={<BookmarkBorderIcon />} sx={{ borderRadius: 2, minWidth: 160, alignSelf: { xs: 'stretch', sm: 'auto' } }}>Save Location</Button>
          </Box>
        </Paper>
      ) : (
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3, textAlign: 'center' }} elevation={4}>
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>No Upcoming Stays</Typography>
          <Typography variant="body2" sx={{ color: '#b0b8c1', mb: 3 }}>
            You don't have any upcoming bookings. Start planning your next trip!
          </Typography>
          <Button variant="contained" color="primary" sx={{ borderRadius: 2 }}>
            Book Your Next Stay
          </Button>
        </Paper>
      )} */}

     <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 6, lg: 6, xl: 6}} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
          {bookingsLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
              <CircularProgress sx={{ color: '#3776FF' }} />
            </Box>
          ) : bookings.length === 0 ? (
            <Box sx={{ py: 0 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', gap: 2 }}>
                <Typography fontSize={30} variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
                  Current Booking Status
                </Typography>
                <Box sx={{ 
                  backgroundColor: '#131A21', 
                  borderRadius: '12px', 
                  p: 4,
                  py:13.5, 
                  width: '100%',
                  textAlign: 'center'
                }}>
                  <Typography sx={{ color: '#b0b8c1', fontSize: 18, fontWeight: 500, mb: 1 }}>
                    No Active Booking
                  </Typography>
                  <Typography sx={{ color: '#6A6E71', fontSize: 14, mb: 3 }}>
                    You don't have any active bookings at the moment
                  </Typography>
                  <Button 
                    variant="contained" 
                    sx={{ 
                      backgroundColor: '#3776FF', 
                      color: '#fff', 
                      borderRadius: 2,
                      textTransform: 'none',
                      px: 3,
                      py: 1.5,
                      '&:hover': {
                        backgroundColor: '#1d4ed8',
                      }
                    }}
                    onClick={() => navigate('/')}
                  >
                    Browse Available Botels
                  </Button>
                </Box>
              </Box>
            </Box>
          ) : (
            <>
              <Box sx={{ justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: 2, gap: 2, }}>
                <Box>
                  <Box  sx={{
                              display: "flex",
                              alignItems: "center", // vertically center
                              gap: 1,   
                              justifyContent: 'space-between', 
                              mb: currentBookingPin ? 3 : "-3px",           // optional spacing between items
                            }}>
                  <Typography fontSize={30} variant="subtitle1" fontWeight="bold">Current Booking Status</Typography>
                  <Typography sx={{ 
                                    background: currentBookingStatus === "cancelled" 
                                      ? "#E2322061" 
                                      : currentBookingStatus === "Completed" 
                                      ? "#05966961"
                                      : currentBookingStatus === "Ongoing"
                                      ? "#3776FF61"
                                      : "#cf952f61",
                                    color: currentBookingStatus === "cancelled"
                                      ? "#FFAEA6"
                                      : currentBookingStatus === "Completed"
                                      ? "#2CEFA7"
                                      : currentBookingStatus === "Ongoing"
                                      ? "#90caf9"
                                      : "#FFB135",
                                    fontSize: '16px',
                                    padding: '7px 10px',
                                    borderRadius: '50px',
                                    fontWeight: 'bold',
                                    textTransform: 'capitalize' }} >{currentBookingStatus}</Typography>
                  </Box>
                </Box>
              </Box>
              <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      p: "30px",
      backgroundColor: "#131A21",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "2",
    }}
  >
    Check-In <br />

    {/* ICON + DATE ROW */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
      <img
        src="/icons/calender-icon.svg"
        alt="calendar icon"
        style={{ width: 22, height: 22 }}
      />
      <Box sx={{ fontSize: "20px", fontWeight: "bold" }}>
        {currentBookingCheckIn}
      </Box>
    </Box>
  </Typography>

  <Typography
    sx={{
      flex: 1, // equal width
      p: "30px",
      backgroundColor: "#131A21",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "2",
    }}
  >
    Check-Out <br />

    {/* ICON + DATE ROW */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
      <img
        src="/icons/calender-icon.svg"
        alt="calendar icon"
        style={{ width: 22, height: 22 }}
      />
      <Box sx={{ fontSize: "20px", fontWeight: "bold" }}>
        {currentBookingCheckOut}
      </Box>
    </Box>
  </Typography>
</Box>
{bookings[0].identity_verified ? (
  <>
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", md: "row" }, // row on large screens
      alignItems: "stretch",
      gap: 2,
      mt:3,
    }}
  >
    <Typography
      sx={{
        flex: 1, // equal width
        fontSize: "18px"
      }}
    >
      Locker:
    </Typography>
  
    {/* <Typography sx={{ fontWeight: "bold", fontSize: "16px"}}>
      Suite
    </Typography> */}
  </Box>
  
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", md: "row" }, 
      alignItems: "center",
      justifyContent: "space-between",  // equal spacing
      gap: 2,
      mt: 1,
    }}
  >
    <Typography
      sx={{
        flex: 1, // equal width
        fontSize: "18px",
      }}
    >
      Pin:
    </Typography>
  
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1 }}>
        {/* Text */}
        <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
          {showPin ? pin : "* * * * * * *"}
        </Typography>
        {/* Eye Icon */}
        <Box
          onClick={() => setShowPin(!showPin)}
          sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          {showPin ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" sx={{marginTop:"-7px"}}/>}
        </Box>
      </Box>
  
    <Typography onClick={handleOpenQrModal} sx={{ fontWeight: "normal", fontSize: "16px", borderRadius:"5px", backgroundColor:"#3776FF", py:"5px", px:"10px", cursor:"pointer", transition: "0.3s ease",
      "&:hover": {
        opacity: 0.5,
      },}}>
      View QR
    </Typography>
  
  </Box>
  </>
) : (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: 3}}>
  {emailSent ? (
    <Typography sx={{ fontWeight: "normal", fontSize: "16px", textAlign: 'center', mt: 3, textTransform:"capitalize"}}>Verification email sent successfully! Check your inbox.</Typography>
  ) : (
    <>
  <Typography sx={{ fontWeight: "normal", fontSize: "16px", textAlign: 'center', mt: 3, textTransform:"capitalize"}}>Click to verify your identity to generate Locker PIN</Typography>
  <Button onClick={handleIdentityVerification} variant="contained" 
  disabled={verificationLoading}
  sx={{ color:"white", borderRadius: 2, alignItems: 'center', transition: "0.3s ease", background: "#a33540",
    width: "100%",
    marginTop: "15px",
    "&:hover": {
      opacity: 0.5,
    },
    "&:disabled": {
      opacity: 0.6,
    }}}>
    {verificationLoading ? (
      <CircularProgress size={20} sx={{ color: 'white', mr: 1 }} />
    ) : (
      <PermIdentityIcon sx={{ fontSize: 28, marginRight: "5px"}} />
    )}
    {verificationLoading ? "Sending..." : "Verify Your Identity"}
  </Button>
  </>
  )}
  </Box>
)}

            <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', sm: 'auto' } , mt: 4, justifyContent: 'space-between', mb: 3}}>
              <Button 
                onClick={() => setSelectedSection("Extend Stay")} 
                variant="contained" 
                disabled={bookings[0]?.status === "cancelled" || bookings[0]?.status === "checked out"}
                sx={{
                  color:"white", 
                  borderRadius: 2, 
                  minWidth: 120, 
                  alignItems: 'center',
                  "&:disabled": {
                    opacity: 0.5,
                    cursor: "not-allowed"
                  }
                }}>
                <img
                  src="/icons/button-icon-white.svg"
                  alt="calendar icon"
                  style={{ width: 22, height: 22, marginRight: 10}}
                /> Extend Stay
              </Button>
              <Button 
                onClick={() => setSelectedSection("Confirm Check-Out")} 
                variant="contained" 
                disabled={bookings[0]?.status === "cancelled" || bookings[0]?.status === "checked out"}
                sx={{
                  backgroundColor:"#D0D0D0", 
                  color:"black", 
                  borderRadius: 2, 
                  minWidth: 120, 
                  alignItems: 'center', 
                  transition: "0.3s ease",
                  "&:hover": {
                    opacity: 0.5,
                  },
                  "&:disabled": {
                    opacity: 0.5,
                    cursor: "not-allowed"
                  }
                }}>
                <img
                  src="/icons/button-icon-black.svg"
                  alt="calendar icon"
                  style={{ width: 22, height: 22, marginRight: 10}}
                /> Check-Out
              </Button>
              <Button 
                variant="contained" 
                disabled={bookings[0]?.status === "cancelled" || bookings[0]?.status === "checked out"}
                sx={{
                  backgroundColor:"#E23220", 
                  color:"white", 
                  borderRadius: 2, 
                  minWidth: 120, 
                  alignItems: 'center', 
                  transition: "0.3s ease",
                  "&:hover": {
                    opacity: 0.5,
                  },
                  "&:disabled": {
                    opacity: 0.5,
                    cursor: "not-allowed"
                  }
                }} 
                onClick={handleOpenCancellationModal}>
                <img
                  src="/icons/button-icon-white.svg"
                  alt="calendar icon"
                  style={{ width: 22, height: 22, marginRight: 10}}
                /> Cancel Booking
              </Button>
              <Button onClick={() => setSelectedSection("Report an Issue")} variant="contained" sx={{backgroundColor:"#45518F", color:"white", borderRadius: 2, minWidth: 120, alignItems: 'center', transition: "0.3s ease",
                "&:hover": {
                  opacity: 0.5,
                },}}>
                            <img
                  src="/icons/button-icon-white.svg"
                  alt="calendar icon"
                  style={{ width: 22, height: 22, marginRight: 10}}
                />Report Issue
              </Button>
              </Box>
              {currentBookingPin && (
              <Typography sx={{ fontWeight: "normal", fontSize: "16px", textAlign: 'center', mt: 3, pb:"6px"}}>
                PIN rotates after extensions and at checkout.
              </Typography>
              )}
              {/* <Box sx={{ background: '#181F2A', p: 2, borderRadius: 2, mb: 2, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'space-between', gap: 2}}>
                <Box>
                  <Typography sx={{ color: '#b0b8c1' }}>Check-In Starts In</Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {formatTimeUntilCheckIn( 0,  0,  0)}
                  </Typography>
                </Box>
                <Button variant="contained" color="primary" startIcon={<BookmarkBorderIcon />} sx={{ borderRadius: 2, minWidth: 160, alignSelf: { xs: 'stretch', sm: 'auto' } }}>Save Location</Button>
              </Box> */}
            </>
          )}
        </Paper>
          </Grid>
          <Grid size={{xs: 12, md: 6, lg: 6, xl: 6}} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3, position: 'relative' }} elevation={4}>
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              borderRadius: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
              backdropFilter: 'blur(2px)',
            }}
          >
            <Typography
              sx={{
                color: '#9ca3af',
                fontSize: 24,
                fontWeight: 'bold',
                mb: 1,
              }}
            >
              Coming Soon
            </Typography>
            <Typography
              sx={{
                color: '#6b7280',
                fontSize: 16,
                textAlign: 'center',
                px: 2,
              }}
            >
              This feature will be available in a future release
            </Typography>
          </Box>
          <Box sx={{ justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: 2, gap: 2, pb: 8.5}}>
            <Box>
              <Box  sx={{
                          display: "flex",
                          alignItems: "center", // vertically center
                          gap: 1,   
                          justifyContent: 'space-between', 
                          mb: 3,           // optional spacing between items
                        }}>
              <Typography fontSize={30} variant="subtitle1" fontWeight="bold">Package Protection</Typography>
              <Typography sx={{ background:" #7B3EA9",
                                fontSize: '16px',
                                padding: '12px 35px',
                                borderRadius: '10px',
                                fontWeight: 'bold' }} >Premium</Typography>
              </Box>
            </Box>

<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
    mt:3,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      fontSize: "18px"
    }}
  >
    Renews:
  </Typography>

  <Typography sx={{ fontWeight: "bold", fontSize: "16px"}}>
  2025-11-01
  </Typography>
</Box>
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
    mt:3,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      fontSize: "18px"
    }}
  >
    Members:
  </Typography>

  <Typography sx={{ fontWeight: "bold", fontSize: "16px"}}>
  4 household member(s)
  </Typography>
</Box>
  <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', sm: 'auto' } , mt: 6, justifyContent: 'space-between', mb: 3}}>
              <Button onClick={() => setSelectedSection("Upgrade or Downgrade Plan")} variant="contained" disabled sx={{flex:1, color:"white", borderRadius: 2, minWidth: 120, alignItems: 'center' }}>
                <img
                  src="/icons/button-icon-white.svg"
                  alt="calendar icon"
                  style={{ width: 22, height: 22, marginRight: 10}}
                /> Upgrade / Downgrade
              </Button>
              <Button onClick={() => setSelectedSection("Manage Your Household")} variant="contained" disabled sx={{flex:1, backgroundColor:"#D0D0D0", color:"black", borderRadius: 2, minWidth: 120, alignItems: 'center', transition: "0.3s ease",
                "&:hover": {
                  opacity: 0.5,
                },}}>
                <img
                  src="/icons/button-icon-black.svg"
                  alt="calendar icon"
                  style={{ width: 22, height: 22, marginRight: 10}}
                /> Manage
              </Button>
              <Button onClick={() => setSelectedSection("Invite Household Member")} variant="contained" disabled sx={{flex:1, backgroundColor:"#A33540", color:"white", borderRadius: 2, minWidth: 120, alignItems: 'center', transition: "0.3s ease",
                "&:hover": {
                  opacity: 0.5,
                },}}>
                <img
                  src="/icons/button-icon-white.svg"
                  alt="calendar icon"
                  style={{ width: 22, height: 22, marginRight: 10}}
                /> Invite Household
              </Button>
             
            </Box>
            <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
    mt:3,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      fontSize: "18px"
    }}
  >
    local:
  </Typography>

  <Typography sx={{ fontWeight: "bold", fontSize: "16px"}}>
  up to 2 members
  </Typography>
</Box>
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
    mt:3,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      fontSize: "18px"
    }}
  >
    Premium:
  </Typography>

  <Typography sx={{ fontWeight: "bold", fontSize: "16px"}}>
  up to 5
  </Typography>
</Box>
          </Box>
          {/* <Box sx={{ background: '#181F2A', p: 2, borderRadius: 2, mb: 2, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'space-between', gap: 2}}>
            <Box>
              <Typography sx={{ color: '#b0b8c1' }}>Check-In Starts In</Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatTimeUntilCheckIn( 0,  0,  0)}
              </Typography>
            </Box>
            <Button variant="contained" color="primary" startIcon={<BookmarkBorderIcon />} sx={{ borderRadius: 2, minWidth: 160, alignSelf: { xs: 'stretch', sm: 'auto' } }}>Save Location</Button>
          </Box> */}
        </Paper>
          </Grid>
     </Grid>
       
      
     <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
          <Box sx={{ justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: 2, gap: 2 }}>
            <Box>
              <Box  sx={{
                          display: "flex",
                          alignItems: "center", // vertically center
                          gap: 1,   
                          justifyContent: 'space-between', 
                          mb: 3,           // optional spacing between items
                        }}>
              <Typography fontSize={24} variant="subtitle1" fontWeight="bold">Analytics</Typography>
              </Box>
            </Box>
            <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      px: "25px", py: "15px",
      backgroundColor: "#131A21",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "medium",
      lineHeight: "2",
    }}
  >
    Total Bookings <br />

    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
      <Box sx={{ fontSize: "24px", fontWeight: "bold" }}>
        {totalBookings}
      </Box>
    </Box>
  </Typography>

  {/* <Typography
    sx={{
      flex: 1, // equal width
      px: "25px", py: "15px",
      backgroundColor: "#131A21",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "medium",
      lineHeight: "2",
    }}
  >
    Total Deliveries <br />

    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
      <Box sx={{ fontSize: "24px", fontWeight: "bold" }}>
        24
      </Box>
    </Box>
  </Typography> */}
  <Typography
    sx={{
      flex: 1, // equal width
      px: "25px", py: "15px",
      backgroundColor: "#131A21",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "medium",
      lineHeight: "2",
    }}
  >
    Avg. Stay Duration <br />

    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
      <Box sx={{ fontSize: "24px", fontWeight: "bold" }}>
      {avgStayDuration} hour(s)
      </Box>
    </Box>
  </Typography>
</Box>

            
          </Box>
          {/* <Box sx={{ background: '#181F2A', p: 2, borderRadius: 2, mb: 2, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'space-between', gap: 2}}>
            <Box>
              <Typography sx={{ color: '#b0b8c1' }}>Check-In Starts In</Typography>
              <Typography variant="h6" fontWeight="bold">
                {formatTimeUntilCheckIn( 0,  0,  0)}
              </Typography>
            </Box>
            <Button variant="contained" color="primary" startIcon={<BookmarkBorderIcon />} sx={{ borderRadius: 2, minWidth: 160, alignSelf: { xs: 'stretch', sm: 'auto' } }}>Save Location</Button>
          </Box> */}
          {/* <Box sx={{ display: "flex", gap: 2, mt:"30px", mb:"30px" }}>
      <Button
        sx={{
          backgroundColor: selected === "Bookings" ? "#3776FF" : "#131A21",
          color: "#fff",
          borderRadius: "12px",
          padding: "10px 20px",
          fontSize: "16px",
          fontWeight: "medium",
          lineHeight: "2",
          flex: 1,
        }}
        onClick={() => setSelected("Bookings")}
      >
        Bookings
      </Button>

      <Button
        sx={{
          backgroundColor: selected === "Deliveries" ? "#3776FF" : "#131A21",
          color: "#fff",
          borderRadius: "12px",
          padding: "10px 20px",
          fontSize: "16px",
          fontWeight: "medium",
          lineHeight: "2",
          flex: 1,
        }}
        onClick={() => setSelected("Deliveries")}
      >
        Deliveries
      </Button>
    </Box> */}
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#283441' }}>
              <TableCell align="left" colSpan={4} sx={{ backgroundColor: '#283441', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', fontSize:"20px", fontWeight:"semibold" }}>
                {selected}
              </TableCell>
            </TableRow>
            <TableRow >
              {columns.map((column, index) => (
                <TableCell
                  sx={{ fontSize:"16px", fontWeight:"medium", backgroundColor: '#192633', borderRight: index !== columns.length - 1 ? '1px solid #2C353F' : 'none', }}
                  key={column.id}
                  align={column.align}
                  style={{ top: 57, minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: '#131A21' }}>
            {bookingsLoading ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  <CircularProgress sx={{ color: '#3776FF' }} />
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 6 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ color: '#b0b8c1', fontSize: 16, fontWeight: 500 }}>
                      No bookings found
                    </Typography>
                    <Typography sx={{ color: '#6A6E71', fontSize: 14 }}>
                      Your booking history will appear here
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row:any) => {
                return (
                  <TableRow 
                    hover 
                    role="checkbox" 
                    tabIndex={-1} 
                    key={row.id}
                    onClick={() => navigate(`/client/modify-booking/${row.id}`)}
                    sx={{ 
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)'
                      }
                    }}
                  >
                    {columns.map((column) => {
                      const value = row[column.id as keyof Data];
                      return (
                        <TableCell
  key={column.id}
  align={column.align}
  sx={{ fontSize: "14px", fontWeight: "medium" }}
>
  <Typography
    sx={{
      display: "inline-block",
      px: 1.5,
      py: 0.5,
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: "normal",
      textTransform: "capitalize",

      backgroundColor:
        value === "Identity Not Verified"
          ? "#965E05"
          : value === "Identity Verified"
          ? "#059669"
          : value === "confirmed (Overstay)"
          ? "#E23220"
          : value === "One-Time"
          ? "#059669"
          : value === "Subscription"
          ? "#7B3EA9"
          : value === "cancelled"
          ? "#E23220"
          : "transparent",

      color:
        value === "Identity Not Verified"
          ? "#FFB135"
          : value === "Identity Verified"
          ? "#2CEFA7"
          : value === "confirmed (Overstay)"
          ? "#FFDFDB"
          : value === "One-Time"
          ? "#2CEFA7"
          : value === "Subscription"
          ? "#D6A1FF"
          : value === "cancelled"
          ? "#FFAEA6"
          : "#fff",
    }}
  >
    {column.format && typeof value === "number"
      ? column.format(value)
      : value}
  </Typography>
</TableCell>

                      );
                    })}
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalBookings}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
        </Paper>
          </Grid>
        
     </Grid>

     <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
          <Box sx={{ justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: 2, gap: 2 }}>
            <Box>
              <Box  sx={{
                          display: "flex",
                          alignItems: "center", // vertically center
                          gap: 1,   
                          justifyContent: 'space-between', 
                          mb: 3,           // optional spacing between items
                        }}>
              <Typography fontSize={24} variant="subtitle1" fontWeight="bold">Payment History</Typography>
              </Box>
            </Box>
            
          </Box>

          <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#283441' }}>
              <TableCell align="left" colSpan={4} sx={{ backgroundColor: '#283441', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', fontSize:"20px", fontWeight:"semibold" }}>
               Payments
              </TableCell>
            </TableRow>
            <TableRow >
                {paymentColumns.map((column, index) => (
                <TableCell
                  sx={{ fontSize:"16px", fontWeight:"medium", backgroundColor: '#192633', borderRight: index !== columns.length - 1 ? '1px solid #2C353F' : 'none', }}
                  key={column.id}
                  align={column.align}
                  style={{ top: 57, minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: '#131A21' }}>
            {paymentHistoryLoading ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  <CircularProgress sx={{ color: '#3776FF' }} />
                </TableCell>
              </TableRow>
            ) : paymentRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 6 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{ color: '#b0b8c1', fontSize: 16, fontWeight: 500 }}>
                      No payment history found
                    </Typography>
                    <Typography sx={{ color: '#6A6E71', fontSize: 14 }}>
                      Your payment transactions will appear here
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              paymentRows.map((row:any) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.date as keyof PaymentData}>
                    {paymentColumns.map((column) => {
                      const value = row[column.id as keyof PaymentData];
                      return (
                        <TableCell
  key={column.id}
  align={column.align}
  sx={{ fontSize: "14px", fontWeight: "medium" }}
>
  <Typography
    sx={{
      display: "inline-block",
      px: 1.5,
      py: 0.5,
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: "normal",
      textTransform: "capitalize",

      backgroundColor:
        value === "InProgress"
          ? "#965E05"
          : value === "completed"
          ? "#059669"
          : value === "succeeded"
          ? "#059669"
          : value === "failed"
          ? "#E23220"
          : value === "refunded"
          ? "#E23220"
          : value === "pending"
          ? "#965E05"
          : value === "processing"
          ? "#965E05"
          : value === "canceled"
          ? "#E23220"
          : value === "expired"
          ? "#E23220"
          : "transparent",

      color:
        value === "InProgress"
          ? "#FFB135"
          : value === "completed"
          ? "#2CEFA7"
          : value === "succeeded"
          ? "#2CEFA7"
          : value === "failed"
          ? "#FFDFDB"
          : value === "refunded"
          ? "#FFAEA6"
          : value === "pending"
          ? "#965E05"
          : value === "processing"
          ? "#965E05"
          : value === "canceled"
          ? "#E23220"
          : value === "expired"
          ? "#E23220"
          : "#fff",
    }}
  >
    {column.format && typeof value === "number"
      ? column.format(value)
      : value}
  </Typography>
</TableCell>

                      );
                    })}
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* NEED CHANGE */}
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={totalPaymentHistory}
        rowsPerPage={paymentRowsPerPage}
        page={paymentPage}
        onPageChange={handlePaymentChangePage}
        onRowsPerPageChange={handlePaymentChangeRowsPerPage}
      />
        </Paper>
          </Grid>
        
     </Grid>

{/* Rating and Reviews Section Start */}
<Grid container spacing={3}>
        <Grid size={{xs: 12, md: 6, lg: 6, xl: 6}} >
        <Paper sx={{ py:"82px", mb: 3, background: '#1F262C', borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}} elevation={4}>
          <Typography sx={{ pb: "25px" }} fontSize={30} variant="subtitle1" fontWeight="bold">Share Your Stay Experience</Typography>
          <Typography sx={{ pb: "20px" }} fontSize={20} variant="body2">Rate Your Stay</Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
      {[1, 2, 3, 4, 5].map((star) => {
        const isFilled = star <= (hover || rating);

        return (
          <IconButton
            key={star}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
            onClick={() => setRating(star)}
            disableRipple
            sx={{
              width: 35,
              height: 34,
              padding: 0,
            }}
          >
            <RoundedStar filled={isFilled} />
          </IconButton>
        );
      })}
    </Box>
        </Paper>
          </Grid>
          <Grid size={{xs: 12, md: 6, lg: 6, xl: 6}} sx={{ display: 'flex', flexDirection: 'column', gap: 2, "& .MuiPaper-root": {
        backgroundColor: "#131a2100",
        boxShadow: "none",        // removes Paper shadow
        backgroundImage: "none", 
        px:0,  // removes Paper overlay
        pt:0,
        pb:"15px",
        m:0,
    }, "& .MuiBox-root":{
      minWidth:"100%"
    }}}>
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, borderRadius: 3, backgroundColor:"#131A21"}} elevation={4}>
        <Box sx={{ width: "100%", maxWidth: 600, mx: "auto" }}>
      <Typography sx={{ fontSize: "16px", pb: "10px" }}>Your Feedback</Typography>

      {/* TEXTAREA */}
      <TextField
        multiline
        minRows={6}
        fullWidth
        placeholder="Tell us about your experience..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        sx={{
          mb: 2,
          borderRadius: "10px",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#2C353F",
              borderWidth: "2px",
            },
            "&:hover fieldset": {
              borderColor: "#2C353F",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#2C353F",
            },
          },
        }}
      />

      {/* SUCCESS OR ERROR MESSAGE */}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Feedback sent successfully!
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Please fill the form to send feedback.
        </Alert>
      )}

      {/* SEND BUTTON */}
      <Button
        fullWidth
        onClick={handleSend}
        sx={{
          backgroundColor: "#2050B3",
          color: "#fff",
          borderRadius: "10px",
          fontSize: "16px",
          fontWeight: "bold",
          py: 1.5,
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#1B449A",
          },
        }}
        startIcon={
          <SendOutlinedIcon
            sx={{
              transform: "rotate(-40deg)",
              fontSize: 30,
              position: "relative",
              top: "-3px",
            }}
          />
        }
      >
        Submit Review
      </Button>

      <Typography
        align="center"
        fontSize={16}
        sx={{ pt: "10px", color: "#AFAFAF" }}
      >
        Your feedback helps us improve our services
      </Typography>
    </Box>
        </Paper>
          </Grid>
     </Grid>
{/* Rating and Reviews Section End */}
</Box>
    )}

{/* Extend Stay Section Start */}
{selectedSection === "Extend Stay" && (
<Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
<Grid container spacing={3} sx={{ backgroundColor: '#1F262C', borderRadius: 3, p:"30px" }}>
<Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} >
<Typography sx={{ pb: "10px", textAlign: 'left',
    "& svg":{
      display:"block",
    } }} fontSize={24} variant="subtitle1" fontWeight="bold">Extend Your Stay 
  <span onClick={() => setSelectedSection("Guest Overview")} style={{ cursor: "pointer", color: "white", fontSize: 16, fontWeight: "bold" , float: "right", border: "1px solid white", borderRadius: "4px", padding: "4px 20px"
  }}>
    <ArrowBackOutlinedIcon />
  </span>
  </Typography>
          <Typography sx={{ pb: "15px", textAlign: 'left' }} fontSize={18} variant="subtitle1" fontWeight="regular">Select an extension option to extend your current booking.</Typography>
          </Grid>
          <Grid size={{xs: 12, md: 4}}>
            <Paper onClick={() => {
                  if (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') return;
                  setSelectedExtension('4hours');
                  setExtendDialogOpen(true);
                }} sx={{ p: 2, py: "40px", background: '#131A21', borderRadius: "20px", textAlign: 'center', cursor: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 'not-allowed' : 'pointer', opacity: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 0.5 : 1, "&:hover": { opacity: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 0.5 : 0.5 } }} elevation={2}>
            <LocationOnOutlinedIcon sx={{ color: 'white', fontSize: 40 }} />
              <Typography variant="h6" sx={{ fontSize: "18px", pt: "10px"}}>Extend +4 Hours</Typography>
              <Typography variant="body2" sx={{ color: "white", fontSize: "16px", pt: "10px" }}>${getExtensionPrice('4hours').toFixed(2)}</Typography>
       
            </Paper>
          </Grid>
          <Grid size={{xs: 12, md: 4}}>
            <Paper onClick={() => {
                  if (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') return;
                  setSelectedExtension('8hours');
                  setExtendDialogOpen(true);
                }} sx={{ p: 2, py: "40px", background: '#131A21', borderRadius: "20px", textAlign: 'center', cursor: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 'not-allowed' : 'pointer', opacity: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 0.5 : 1, "&:hover": { opacity: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 0.5 : 0.5 } }} elevation={2}>
            
            <img
                  src="/icons/say-goodbey.svg"
                  alt="calendar icon"
                  style={{ width: 40, height: 40, marginRight: 10}}
          />
              <Typography variant="h6" sx={{ fontSize: "18px", pt: "10px"}}>Extend +8 Hours</Typography>
              <Typography variant="body2" sx={{ color: "white", fontSize: "16px", pt: "10px" }}>${getExtensionPrice('8hours').toFixed(2)}</Typography>
       
            </Paper>
          </Grid>
          <Grid size={{xs: 12, md: 4}}>
            <Paper onClick={() => {
                  if (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') return;
                  setSelectedExtension('fullday');
                  setExtendDialogOpen(true);
                }} sx={{ p: 2, py: "40px", background: '#131A21', borderRadius: "20px", textAlign: 'center', cursor: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 'not-allowed' : 'pointer', opacity: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 0.5 : 1, "&:hover": { opacity: (bookings[0]?.status === 'cancelled' || bookings[0]?.status === 'checked out') ? 0.5 : 0.5 } }} elevation={2}>
            <img
                  src="/icons/clock-icon.svg"
                  alt="calendar icon"
                  style={{ width: 40, height: 40, marginRight: 10}}
          />
              <Typography variant="h6" sx={{ fontSize: "18px", pt: "10px"}}>Full Day Extension</Typography>
              <Typography variant="body2" sx={{ color: "white", fontSize: "16px", pt: "10px" }}>
              ${getExtensionPrice('fullday').toFixed(2)}
              </Typography>
       
            </Paper>
          </Grid>
      </Grid>

      </Box>
    )}

{/* Extend Stay Dialog */}
      <Dialog sx={{ "& .MuiPaper-root": { borderRadius: "20px", backgroundColor: "#1F262C !important", backgroundImage: "none !important" } }} open={extendDialogOpen} onClose={() => setExtendDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: '#fff' }}>Extend Your Stay</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2, color: '#fff' }}>
            Are you sure you want to extend your stay by {selectedExtension === '4hours' ? '4 hours' : selectedExtension === '8hours' ? '8 hours' : 'a full day'}?
          </Typography>
          <Typography variant="body2" sx={{ color: '#b0b8c1' }}>
            Additional cost: ${selectedExtension ? getExtensionPrice(selectedExtension).toFixed(2) : '0.00'}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" sx={{ borderRadius: 2, color: 'white', borderColor: 'white' }} onClick={() => setExtendDialogOpen(false)} disabled={extendStayLoading}>
            Cancel
          </Button>
          <Button 
            onClick={handleExtendStay} 
            variant="contained" 
            disabled={extendStayLoading}
            sx={{ borderRadius: 2 }}
          >
            {extendStayLoading ? <CircularProgress size={20} /> : 'Confirm Extension'}
          </Button>
        </DialogActions>
      </Dialog>
{/* Extend Stay Section End */}



{/* Check-Out Section Start */}
{selectedSection === "Confirm Check-Out" && (
<Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
<Grid container spacing={3} sx={{ backgroundColor: '#1F262C', borderRadius: 3, p:"30px" }}>
<Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} >
<Typography sx={{ pb: "10px", textAlign: 'left',
    "& svg":{
      display:"block",
    } }} fontSize={24} variant="subtitle1" fontWeight="bold">Confirm your Check-out
  <span onClick={() => setSelectedSection("Guest Overview")} style={{ cursor: "pointer", color: "white", fontSize: 16, fontWeight: "bold" , float: "right", border: "1px solid white", borderRadius: "4px", padding: "4px 20px"
  }}>
    <ArrowBackOutlinedIcon />
  </span>
  </Typography>
          <Typography sx={{ pb: "0", textAlign: 'left' }} fontSize={18} variant="subtitle1" fontWeight="regular">Are you sure you want to check out of your locker? Your current PIN will be deactivated and your access window will
          end.</Typography>
          </Grid>
          <Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} sx={{"& .MuiPaper-root": {
        backgroundColor: "#131A21",
        boxShadow: "none",        // removes Paper shadow
        backgroundImage: "none",  }}}>
        <Paper sx={{ p:"30px", mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'column', "& button.MuiIconButton-root" :{
          display: "none",
        }, "& .MuiInputBase-root":{
          p:0,
        }}} elevation={4}>
          <Typography fontSize={16} >Current Booking Details:</Typography>
          <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
    mt:3,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      fontSize: "18px"
    }}
  >
    Locker:
  </Typography>

  <Typography sx={{ fontWeight: "bold", fontSize: "16px"}}>
    Suite
  </Typography>
</Box>
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // row on large screens
    alignItems: "stretch",
    gap: 2,
    mt:3,
  }}
>
  <Typography
    sx={{
      flex: 1, // equal width
      fontSize: "18px"
    }}
  >
    End Date:
  </Typography>

  <Typography sx={{ fontWeight: "bold", fontSize: "16px"}}>
  2025-10-221  12:00 PM
  </Typography>
</Box>

          
        </Paper>
        </Grid>
        <Button 
          variant="contained" 
          color="primary" 
          sx={{mt:"-20px", width:"100%", backgroundColor: "#3776FF", color: "#fff", borderRadius: 2, fontSize: 16, fontWeight: "bold", py: 1.5, textTransform: "none", "&:hover": { opacity: 0.5 } }}
          onClick={handleCheckout}
          disabled={checkoutLoading || !bookings || bookings.length === 0 || bookings[0]?.status === 'cancelled'}
        >
          {checkoutLoading ? (
            <>
              <CircularProgress size={20} sx={{ color: '#fff', mr: 1 }} />
              Checking Out...
            </>
          ) : (
            <>
              <img
                src="/icons/button-icon-white.svg"
                alt="calendar icon"
                style={{ width: 22, height: 22, marginRight: 10}}
              />
              Confirm Check-Out
            </>
          )}
        </Button>
      </Grid>

      </Box>
    )}
{/* Check-Out Section End */}

{/* Report Issue Section Start */}
{selectedSection === "Report an Issue" && (
<Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
<Grid container spacing={3} sx={{ backgroundColor: '#1F262C', borderRadius: 3, p:"30px" }}>
<Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} >
<Typography sx={{ pb: "10px", textAlign: 'left',
    "& svg":{
      display:"block",
    } }} fontSize={24} variant="subtitle1" fontWeight="bold">
      Report an Issue
  <span onClick={() => setSelectedSection("Guest Overview")} style={{ cursor: "pointer", color: "white", fontSize: 16, fontWeight: "bold" , float: "right", border: "1px solid white", borderRadius: "4px", padding: "4px 20px"
  }}>
    <ArrowBackOutlinedIcon />
  </span>
  </Typography>
          <Typography sx={{ pb: "0", textAlign: 'left' }} fontSize={18} variant="subtitle1" fontWeight="regular">Please describe the issue you are experiencing and we will get back to you as soon as possible.</Typography>

          <Box sx={{ width: "100%" }}>
  <FormControl fullWidth>
    <Typography sx={{ fontSize: 16, mb: "10px", mt: "30px" }}>
      Cancellation Reason
    </Typography>
    <Select
      value={issueValue}
      onChange={handleIssueValueChange}
      displayEmpty
      fullWidth
      sx={{
        borderRadius: "10px",
        backgroundColor: "#222D38",
        "& .MuiSelect-select": {
          padding: "10px", // adjust padding inside select
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none", // remove border if using outlined variant
        },
        "& .MuiSelect-select:empty": {
          color: "#AFAFAF", // gray color for placeholder
        },
      }}
    >
      <MenuItem value="" disabled>
        <em>Select a reason</em>
      </MenuItem>
      <MenuItem value="Locker not opening">Locker not opening</MenuItem>
      <MenuItem value="Lost item">Lost item</MenuItem>
      <MenuItem value="Locker is damaged">Locker is damaged</MenuItem>
      <MenuItem value="Other">Other</MenuItem>
    </Select>
  </FormControl>
</Box>
          </Grid>
          <Typography sx={{ fontSize: 16, mb: "-15px", mt: "10px" }}>
      Description
    </Typography>
          <Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} sx={{"& .MuiPaper-root": {
        backgroundColor: "#131A21",
        boxShadow: "none",        // removes Paper shadow
        backgroundImage: "none",  }}}>
        <Paper sx={{mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'column', "& button.MuiIconButton-root" :{
          display: "none",
        }, "& .MuiInputBase-root":{
          p:0,
        }, "& textarea":{
          p:"20px 15px",
        }}} elevation={4}>


{/* TEXTAREA */}
<TextField
        multiline
        minRows={6}
        fullWidth
        placeholder="Enter a detailed description of the issue"
        value={issueMessage}
        onChange={(e) => setIssueMessage(e.target.value)}
        sx={{
          // mb: 2,
          borderRadius: "10px",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#2C353F",
              borderWidth: "2px",
            },
            "&:hover fieldset": {
              borderColor: "#2C353F",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#2C353F",
            },
          },
        }}
      />

          
        </Paper>
        </Grid>
        <Button variant="contained" color="primary" sx={{mt:"-20px", width:"100%", backgroundColor: "#3776FF", color: "#fff", borderRadius: 2, fontSize: 16, fontWeight: "bold", py: 1.5, textTransform: "none", "&:hover": { opacity: 0.5 } }}
        onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Your issue has been reported. Thank you."); // Update message state
          setSelectedSection("Guest Overview");
          setIssueMessage("");
        }}
        startIcon={
          <SendOutlinedIcon
            sx={{
              transform: "rotate(-40deg)",
              fontSize: 30,
              position: "relative",
              top: "-3px",
            }}
          />
        }
        >
        
        Submit Report
          </Button>

         
      </Grid>

      </Box>
    )}
{/* Report Issue Section End */}


{/* Upgrade/Downgrade Section Start */}

{selectedSection === "Upgrade or Downgrade Plan" && (
<Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
<Grid container spacing={3} sx={{ backgroundColor: '#1F262C', borderRadius: 3, p:"30px" }}>
<Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} >
<Typography sx={{ pb: "10px", textAlign: 'left',
    "& svg":{
      display:"block",
    } }} fontSize={24} variant="subtitle1" fontWeight="bold">Upgrade or Downgrade Plan
  <span onClick={() => setSelectedSection("Guest Overview")} style={{ cursor: "pointer", color: "white", fontSize: 16, fontWeight: "bold" , float: "right", border: "1px solid white", borderRadius: "4px", padding: "4px 20px"
  }}>
    <ArrowBackOutlinedIcon />
  </span>
  </Typography>
          <Typography sx={{ pb: "15px", textAlign: 'left' }} fontSize={18} variant="subtitle1" fontWeight="regular">Select your new check-out date to extend your current booking.</Typography>
          </Grid>
          <Grid size={{xs: 12, md: 6, lg: 6, xl: 6}} sx={{"& .MuiPaper-root": {
        backgroundColor: "#131A21",
        boxShadow: "none",        // removes Paper shadow
        backgroundImage: "none",  }}}>
        <Paper sx={{ p:"30px", mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'column'}} elevation={4}>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"30px"}} >Premium Plan</Typography>
          <Typography fontSize={16} sx={{ color: "#3776FF", pb:"30px"}} >Current Plan</Typography>
          <Typography fontSize={16} sx={{ pb:"30px"}} >Includes protection for up to 5 household and priority support. Ideal for families.</Typography>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"30px"}} >$29.99 / mo</Typography>
          <Button onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Your plan has been changed! Thank you."); // Update message state
          setSelectedSection("Guest Overview");
        }} variant="outlined" color="primary" sx={{ color:"#555555", bgcolor:"#CFCBCB", width:"100%", borderRadius: "10px", fontSize: 16, fontWeight: "bold", py: "14px", textTransform: "none", "&:hover": { opacity: 0.5 } }}>Current Plan</Button>
        </Paper>
        </Grid>
        <Grid size={{xs: 12, md: 6, lg: 6, xl: 6}} sx={{"& .MuiPaper-root": {
        backgroundColor: "#131A21",
        boxShadow: "none",        // removes Paper shadow
        backgroundImage: "none",  }}}>
        <Paper sx={{ p:"30px", mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'column'}} elevation={4}>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"30px"}} >Local Plan</Typography>
          <Typography fontSize={16} sx={{ color: "#3776FF", pb:"30px"}} >Upgrade Now</Typography>
          <Typography fontSize={16} sx={{ pb:"30px"}} >
          Includes protection for up to 2 household members. Great for individuals or couples.
          </Typography>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"30px"}} >$15.99 / mo</Typography>
          <Button onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Your plan has been changed! Thank you."); // Update message state
          setSelectedSection("Guest Overview");
        }} variant="outlined" color="primary" sx={{ color:"white", bgcolor:"#3776FF", width:"100%", borderRadius: "10px", fontSize: 16, fontWeight: "bold", py: "14px", textTransform: "none", "&:hover": { opacity: 0.5 } }}>Downgrade to Local</Button>
        </Paper>
        </Grid>
      </Grid>

      </Box>
    )}

{/* Upgrade/Downgrade Section End */}


{/* Manage Your Household Section Start */}

{selectedSection === "Manage Your Household" && (
<Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
<Grid container spacing={3} sx={{ backgroundColor: '#1F262C', borderRadius: 3, p:"30px" }}>
<Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} >
<Typography sx={{ pb: "10px", textAlign: 'left',
    "& svg":{
      display:"block",
    } }} fontSize={24} variant="subtitle1" fontWeight="bold">Upgrade or Downgrade Plan
  <span onClick={() => setSelectedSection("Guest Overview")} style={{ cursor: "pointer", color: "white", fontSize: 16, fontWeight: "bold" , float: "right", border: "1px solid white", borderRadius: "4px", padding: "4px 20px"
  }}>
    <ArrowBackOutlinedIcon />
  </span>
  </Typography>
          <Typography sx={{ pb: "15px", textAlign: 'left' }} fontSize={18} variant="subtitle1" fontWeight="regular">Manage the members of your package protection plan. You can have up to 5 members on the Premium plan.</Typography>
          </Grid>
          <Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} sx={{"& .MuiPaper-root": {
        backgroundColor: "#131A21",
        boxShadow: "none",        // removes Paper shadow
        backgroundImage: "none",  }}}>
        <Paper sx={{ p:"30px", mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}} elevation={4}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ width: "60px", height: "60px", borderRadius: "7px", marginRight: "30px" }} src="/images/avatar.svg" alt="user" />
          <Box>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"16px"}} >Jane Doe (You)</Typography>
          <Typography fontSize={16} >Primary Account Holder</Typography>
          </Box>
          </Box>
          <Button onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Member removed successfully! Thank you."); // Update message state
          setSelectedSection("Guest Overview");
        }} sx={{ color:"#FFEDEB", bgcolor:"#E23220", borderRadius: "10px", fontSize: 16, fontWeight: "bold", py: "12px",px:"24px", textTransform: "none", "&:hover": { opacity: 0.5 } }}>
          Remove
          </Button>
        </Paper>
        <Paper sx={{ p:"30px", mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}} elevation={4}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ width: "60px", height: "60px", borderRadius: "7px", marginRight: "30px" }} src="/images/avatar.svg" alt="user" />
          <Box>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"16px"}} >Lorem Ipsum</Typography>
          <Typography fontSize={16} >Member</Typography>
          </Box>
          </Box>
          <Button onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Member removed successfully! Thank you."); // Update message state
          setSelectedSection("Guest Overview");
        }} sx={{ color:"#FFEDEB", bgcolor:"#E23220", borderRadius: "10px", fontSize: 16, fontWeight: "bold", py: "12px",px:"24px", textTransform: "none", "&:hover": { opacity: 0.5 } }}>
          Remove
          </Button>
        </Paper>
        <Paper sx={{ p:"30px", mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}} elevation={4}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ width: "60px", height: "60px", borderRadius: "7px", marginRight: "30px" }} src="/images/avatar.svg" alt="user" />
          <Box>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"16px"}} >Sarah Jones</Typography>
          <Typography fontSize={16} >Member</Typography>
          </Box>
          </Box>
          <Button onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Member removed successfully! Thank you."); // Update message state
          setSelectedSection("Guest Overview");
        }} sx={{ color:"#FFEDEB", bgcolor:"#E23220", borderRadius: "10px", fontSize: 16, fontWeight: "bold", py: "12px",px:"24px", textTransform: "none", "&:hover": { opacity: 0.5 } }}>
          Remove
          </Button>
        </Paper>
        <Paper sx={{ p:"30px", mb: 3, borderRadius: 3, width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}} elevation={4}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ width: "60px", height: "60px", borderRadius: "7px", marginRight: "30px" }} src="/images/avatar.svg" alt="user" />
          <Box>
          <Typography fontSize={20} sx={{ fontWeight: "bold", pb:"16px"}} >John Smith</Typography>
          <Typography fontSize={16} >Member</Typography>
          </Box>
          </Box>
          <Button onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Member removed successfully! Thank you."); // Update message state
          setSelectedSection("Guest Overview");
        }} sx={{ color:"#FFEDEB", bgcolor:"#E23220", borderRadius: "10px", fontSize: 16, fontWeight: "bold", py: "12px",px:"24px", textTransform: "none", "&:hover": { opacity: 0.5 } }}>
          Remove
          </Button>
        </Paper>
        </Grid>
      </Grid>
      

      </Box>
    )}

{/* Manage Your Household Section End */}


{/* Invite Household Members Section Start */}

{selectedSection === "Invite Household Member" && (
<Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 10 }}>
<Grid container spacing={3} sx={{ backgroundColor: '#1F262C', borderRadius: 3, p:"30px" }}>
<Grid size={{xs: 12, md: 12, lg: 12, xl: 12}} >
<Typography sx={{ pb: "10px", textAlign: 'left',
    "& svg":{
      display:"block",
    } }} fontSize={24} variant="subtitle1" fontWeight="bold">
      Invite Household Member
  <span onClick={() => setSelectedSection("Guest Overview")} style={{ cursor: "pointer", color: "white", fontSize: 16, fontWeight: "bold" , float: "right", border: "1px solid white", borderRadius: "4px", padding: "4px 20px"
  }}>
    <ArrowBackOutlinedIcon />
  </span>
  </Typography>
          <Typography sx={{ pb: "0", textAlign: 'left' }} fontSize={18} variant="subtitle1" fontWeight="regular">Send an invitation to a new household member to join your package protection plan.</Typography>

          <Box sx={{ width: "100%" }}>
  <FormControl fullWidth>
    <Typography sx={{ fontSize: 16, mb: "10px", mt: "30px" }}>
    Member's Email
    </Typography>
    <TextField
  type="email"
  placeholder="Add Email address"
  fullWidth
  sx={{
    backgroundColor: "#131A21",
    borderRadius: "10px",
    input: { color: "#CACACA", padding: "12px"},
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      "& fieldset": { border: "none" },
    },
  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <PersonAddAltOutlinedIcon sx={{ color: "#CACACA80" }} />
      </InputAdornment>
    ),
  }}
/>
  </FormControl>
</Box>
          </Grid>
        <Button variant="contained" color="primary" sx={{mt:"0px", width:"100%", backgroundColor: "#3776FF", color: "#fff", borderRadius: 2, fontSize: 16, fontWeight: "bold", py: 1.5, textTransform: "none", "&:hover": { opacity: 0.5 } }}
        onClick={() => {
          handleClick();   // Show toast
          setToastMessage("Invitation sent successfully! Thank you."); // Update message state
          setSelectedSection("Guest Overview");
          setIssueMessage("");
        }}
        startIcon={
          <SendOutlinedIcon
            sx={{
              transform: "rotate(-40deg)",
              fontSize: 30,
              position: "relative",
              top: "-3px",
            }}
          />
        }
        >
        
        Send Invitation
          </Button>

         
      </Grid>

      </Box>
    )}

{/* Invite Household Members Section End */}


      {/* Protect Your Stay */}
      {/* {currentStay && (
        <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3, position: 'relative' }} elevation={4}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="subtitle1" fontWeight="bold">Protect Your Stay</Typography>
              <Chip label="Recommended" size="small" sx={{ background: '#1F262C', color: '#90caf9', border: '1px solid #90caf9', fontWeight: 'bold' }} />
            </Box>
            <IconButton sx={{ color: '#FFD700' }}>
              <EmojiEventsIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" sx={{ mb: 2 }}>*82% Of Travelers Protect Their Luggage</Typography>
          <Box sx={{ background: '#1976d2', borderRadius: 2, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}>
            <Typography sx={{ color: '#fff', fontWeight: 500 }}>Add Insurance Now!</Typography>
            <Button size="small" variant="contained" sx={{ background: '#fff', color: '#1976d2', fontWeight: 'bold', borderRadius: 2, ml: 2, '&:hover': { background: '#e3e3e3' } }}>Add</Button>
          </Box>
        </Paper>
      )} */}

      {/* Main Grid */}
      {/* <Grid container spacing={3}>
        <Grid size={{xs: 12, md: 8, lg: 8, xl: 8}} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}> */}
          {/* Booking History */}
          {/* <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
            <Typography variant="h6" fontWeight="bold">Booking History</Typography>
            <Divider sx={{ my: 2, background: '#333' }} />
            {bookingHistory.length > 0 ? (
              <Box sx={{ display: 'flex', gap: 2, overflowX: { xs: 'auto', md: 'visible' }, pb: { xs: 1, md: 0 } }}>
                {bookingHistory.slice(0, 3).map((booking) => (
                  <Paper key={booking.id} sx={{ p: 2, background: '#181F2A', flex: '0 0 260px', minWidth: 220, borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mr: 2 }} elevation={2}>
                    <Typography fontWeight="bold">{booking.botelName}</Typography>
                    <Typography variant="caption" sx={{ mb: 1 }}>
                      {formatDate(booking.checkIn)} - {formatDate(booking.checkOut)}
                    </Typography>
                    <Button 
                      variant="contained" 
                      color={booking.status === 'completed' ? 'success' : booking.status === 'confirmed' ? 'primary' : 'warning'} 
                      size="small" 
                      sx={{ mt: 1, borderRadius: 2 }}
                    >
                      {booking.status.charAt(0).toUpperCase() + booking.status.slice(1)}
                    </Button>
                  </Paper>
                ))}
              </Box>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body2" sx={{ color: '#b0b8c1', mb: 2 }}>
                  No booking history yet
                </Typography>
                <Button variant="contained" color="primary" sx={{ borderRadius: 2 }}>
                  Make Your First Booking
                </Button>
              </Box>
            )}
          </Paper> */}

          {/* Loyalty & Rewards */}
          {/* <Paper sx={{ p: { xs: 2, md: 3 }, background: '#1F262C', borderRadius: 3 }} elevation={4}>
            <Typography variant="h6" fontWeight="bold">Loyalty & Rewards Progress</Typography>
            <Typography variant="body2">Currently At {stats.loyaltyTier} Tier - <b>{stats.loyaltyPoints} Points</b></Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
              <LinearProgress 
                variant="determinate" 
                value={getLoyaltyProgress(stats.loyaltyPoints, stats.loyaltyTier)} 
                sx={{ 
                  flex: 1, 
                  height: 10, 
                  borderRadius: 5, 
                  background: '#181F2A', 
                  '& .MuiLinearProgress-bar': { background: '#FFD700' } 
                }} 
              />
              <Typography sx={{ ml: 2, color: '#fff' }}>
                {stats.pointsToNextTier > 0 ? `${stats.pointsToNextTier} Points Until ${stats.loyaltyTier === 'Bronze' ? 'Silver' : 'Gold'}` : 'Max Tier Reached!'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
              <Typography variant="caption" sx={{ color: '#b0b8c1' }}>Bronze</Typography>
              <Typography variant="caption" sx={{ color: '#b0b8c1' }}>Silver</Typography>
              <Typography variant="caption" sx={{ color: '#FFD700' }}>Gold</Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid size={{xs: 12, md: 4}}> */}
          {/* Reviews */}
          {/* <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3, background: '#1F262C', borderRadius: 3 }} elevation={4}>
            <Typography variant="h6" fontWeight="bold">Your Reviews</Typography>
            {reviews.length > 0 ? (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                  <Rating value={stats.averageRating} readOnly sx={{ color: '#FFD700' }} icon={<StarIcon fontSize="inherit" />} emptyIcon={<StarIcon fontSize="inherit" />} />
                  <Typography variant="body2" fontWeight="bold" sx={{ color: '#FFD700' }}>{stats.averageRating.toFixed(1)}</Typography>
                </Box>
                <Typography variant="body2" sx={{ mt: 1 }}>{reviews[0].review}</Typography>
                <Typography variant="caption" sx={{ color: '#b0b8c1' }}>
                  {reviews[0].botelName} | {formatDate(reviews[0].date)}
                </Typography>
              </>
            ) : (
              <Box sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="body2" sx={{ color: '#b0b8c1', mb: 2 }}>
                  No reviews yet
                </Typography>
                <Typography variant="caption" sx={{ color: '#b0b8c1' }}>
                  Complete a stay to leave a review
                </Typography>
              </Box>
            )} 
          </Paper> */}
          {/* Total Stays */}
          {/* <Paper sx={{ p: { xs: 2, md: 3 }, background: '#1F262C', borderRadius: 3, textAlign: 'center' }} elevation={4}>
            <Typography variant="h6" fontWeight="bold">Total Stays</Typography>
            <Typography variant="h3" color="success.main" fontWeight="bold">{stats.totalStays}</Typography>
            <Typography variant="body2" color="success.main">+{stats.totalStaysThisYear} This Year</Typography>
          </Paper>
        </Grid>
      </Grid> */}

      {/* Footer */}
      <Box sx={{ mt: 5, p: 2, borderTop: '1px solid #1F262C', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, color: '#b0b8c1', fontSize: 14 }}>
        <Typography sx={{ fontSize: 14 }}>© 2025 BOTEL. All rights reserved.</Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button startIcon={<HelpOutlineIcon />} sx={{ color: '#b0b8c1', textTransform: 'none' }}>Help</Button>
          <Button startIcon={<ContactSupportIcon />} sx={{ color: '#b0b8c1', textTransform: 'none' }}>Contact</Button>
        </Box>
      </Box>
    
    </>
  );
};

export default DashboardContent; 